/**
 * Polyfill to ECMA6 String.prototype.contains
 */
if (!String.prototype.contains) {
    String.prototype.contains = function() {
      return String.prototype.indexOf.apply(this, arguments) !== -1;
    };
  }